import type { PortfolioAdminDetail } from '@repo/api-contracts';
import { useProductDetailQuery } from '@/entities/product';
import { beginMoveDrag } from '@/shared/lib';
import { Button } from '@/shared/ui';

export const PortfolioLinkedProduct = ({
  id,
  existing,
  index,
  count,
  disabled,
  onMove,
  onRemove,
  onDropProduct,
}: {
  id: string;
  existing?: PortfolioAdminDetail['products'][number];
  index: number;
  count: number;
  disabled?: boolean;
  onMove: (from: number, to: number) => void;
  onRemove: () => void;
  onDropProduct: (id: string, index: number) => void;
}) => {
  const query = useProductDetailQuery(id);
  const name = query.data?.name ?? existing?.name ?? '선택한 상품';
  const imageUrl = query.data?.images[0]?.url ?? existing?.imageUrl;
  const status = query.data?.status ?? existing?.status;
  return (
    <li
      aria-label={`상품 ${index + 1}`}
      className="flex flex-wrap items-center gap-3 rounded-lg border p-3"
      draggable={!disabled}
      onDragStart={(event) => {
        if (!disabled) beginMoveDrag(event, id);
      }}
      onDragOver={(event) => {
        if (!disabled) event.preventDefault();
      }}
      onDrop={(event) => {
        event.preventDefault();
        if (!disabled) onDropProduct(event.dataTransfer.getData('text/plain'), index);
      }}
    >
      {imageUrl ? (
        <img src={imageUrl} alt="" className="size-12 rounded object-cover" draggable={false} />
      ) : null}
      <div className="flex-1">
        <p>{name}</p>
        {existing?.deletedAt ? (
          <p className="text-sm text-muted-foreground">삭제된 상품 (연결 유지)</p>
        ) : status && status !== 'PUBLISHED' ? (
          <p className="text-sm text-muted-foreground">숨김 상품 (연결 유지)</p>
        ) : null}
        {query.isError && !existing ? (
          <div>
            <p role="alert">상품 정보를 불러오지 못했습니다. 연결 ID는 유지됩니다.</p>
            <Button type="button" size="sm" variant="outline" onClick={() => void query.refetch()}>
              상품 다시 불러오기
            </Button>
          </div>
        ) : null}
      </div>
      <Button
        type="button"
        size="sm"
        variant="outline"
        aria-label={`상품 ${index + 1} 앞으로 이동`}
        disabled={disabled || index === 0}
        onClick={() => onMove(index, index - 1)}
      >
        앞으로
      </Button>
      <Button
        type="button"
        size="sm"
        variant="outline"
        aria-label={`상품 ${index + 1} 뒤로 이동`}
        disabled={disabled || index === count - 1}
        onClick={() => onMove(index, index + 1)}
      >
        뒤로
      </Button>
      <Button
        type="button"
        size="sm"
        variant="outline"
        aria-label={`상품 ${index + 1} 제거`}
        disabled={disabled}
        onClick={onRemove}
      >
        제거
      </Button>
    </li>
  );
};
